module.exports = __webpack_public_path__ + "img/tubulacao.0b982e24.png";